const transitions = {
  defaultDuration: 200
};

export default transitions;
